import { BoundedQueue } from "./BoundedQueue";
const defaultNow = () => typeof performance !== "undefined" && typeof performance.now === "function"
    ? performance.now()
    : Date.now();
export class GpuUploadThrottle {
    constructor(options = {}) {
        var _a, _b, _c;
        this.windowCount = 0;
        this.maxUploadsPerSecond = (_a = options.maxUploadsPerSecond) !== null && _a !== void 0 ? _a : 24;
        this.queue = new BoundedQueue({
            maxSize: (_b = options.maxQueueSize) !== null && _b !== void 0 ? _b : 200,
            dropPolicy: options.dropPolicy,
        });
        this.now = (_c = options.now) !== null && _c !== void 0 ? _c : defaultNow;
        this.windowStartMs = this.now();
    }
    schedule(operation) {
        return this.queue.enqueue(operation);
    }
    runFrame(frameStartMs = this.now()) {
        if (frameStartMs - this.windowStartMs >= 1000) {
            this.windowStartMs = frameStartMs;
            this.windowCount = 0;
        }
        const maxUploadsPerSecond = this.maxUploadsPerSecond;
        let processed = 0;
        while (this.windowCount < maxUploadsPerSecond) {
            const operation = this.queue.dequeue();
            if (!operation) {
                break;
            }
            operation.run();
            processed += 1;
            this.windowCount += 1;
        }
        return {
            processed,
            dropped: this.queue.getDroppedCount(),
            remaining: this.queue.size(),
            windowStartMs: this.windowStartMs,
            windowCount: this.windowCount,
        };
    }
    getQueueDepth() {
        return this.queue.size();
    }
    resetDroppedCount() {
        this.queue.resetDroppedCount();
    }
}
